module.exports = __webpack_public_path__ + "img/formulir-logo-black.ed8f10bb.svg";